/*
 * SpanishWelcomeBanner — retired 2026-07-18.
 *
 * The banner used to offer visitors a one-click switch to the Spanish UI
 * when their browser locale reported `es`. Spanish support has been
 * removed site-wide; this file remains only as a no-op export so imports
 * elsewhere don't need to be scrubbed in one big pass.
 */
const SpanishWelcomeBanner = () => null;

export default SpanishWelcomeBanner;
